"use client";

import { c as _c } from "react/compiler-runtime";
import { useSyncExternalStore } from "react";
import { usePostHog } from "posthog-js/react";
import { sanitizePostHogId } from "@/utils/tracking/posthogId";

/** Re-render auth forms when the idle-initialized SDK has a real browser ID. */
export function usePostHogDistinctId() {
  const $ = _c(2);
  const posthog = usePostHog();
  let t0;
  if ($[0] !== posthog) {
    t0 = () => posthog?.__loaded ? sanitizePostHogId(posthog.get_distinct_id()) : "";
    $[0] = posthog;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useSyncExternalStore(_temp, t0, _temp2);
}
function _temp2() {
  return "";
}
function _temp(listener) {
  window.addEventListener("guestgallery:posthog-loaded", listener);
  return () => window.removeEventListener("guestgallery:posthog-loaded", listener);
}